import React from "react";
import { IRoleBasedCSVExportPluginProps } from "./RoleBasedCSVExportPlugin.types";
import { usePremissions } from "../../PremissionsProvider/PremissionsProvider";
import { CSVExportPlugin } from "../../../components/Table/plugins";

export const RoleBasedCSVExportPlugin: React.FC<
  IRoleBasedCSVExportPluginProps
> = (props) => {
  let { exportAccess,moduleKey } = props;
  const {getPremissionsByModuleId}  = usePremissions();
  const premissions = getPremissionsByModuleId(moduleKey);
  exportAccess = exportAccess || premissions.bulk_export;

  if (exportAccess) {
    return <CSVExportPlugin {...props} />;
  }
  return null;
};
